import { useI18n } from "@wojo/localization";
import { ControlledTabsProvider, Tab, TabList, TabPanel } from "@wojo/ui";
import { useId } from "react";
import { useWeatherContext } from "../../_client/context";
import { RainfallChart } from "./RainfallChart";
import { TemperatureChart } from "./TemperatureChart";
import { MonthlyWeather } from "./types";

type WeatherTabsType = {
    monthlyWeather: MonthlyWeather;
};

export const WeatherTabs: React.FC<WeatherTabsType> = ({ monthlyWeather }) => {
    const { productPage } = useI18n("productPage");
    const { isTemperature, setIsTemperature } = useWeatherContext();
    const contextId = useId();
    const currentTab = isTemperature ? "temperature" : "rainfall";
    const setCurrentTab = (tab: string) => {
        setIsTemperature(tab === "temperature");
    };

    return (
        <ControlledTabsProvider
            contextId={contextId}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
        >
            <TabList
                accessibleTitle={`${productPage.weather.temperature.l()} or ${productPage.weather.rainfall.l()}`}
                variant="minimal"
            >
                <Tab id="temperature" scrollOnSelect={false}>
                    {productPage.weather.temperature.l()}
                </Tab>
                <Tab id="rainfall" scrollOnSelect={false}>
                    {productPage.weather.rainfall.l()}
                </Tab>
            </TabList>
            <TabPanel tabId="temperature">
                <TemperatureChart monthlyWeather={monthlyWeather} />
            </TabPanel>
            <TabPanel tabId="rainfall">
                <RainfallChart monthlyWeather={monthlyWeather} />
            </TabPanel>
        </ControlledTabsProvider>
    );
};
